export default "__VITE_ASSET__CUB39yeC__"